import { MuiAlert, Typography, strIsNullOrEmpty } from '@fox/atoms';
import { FlexRowSmallSpaced } from '@fox/layout';
import React from 'react';
import styled from 'styled-components';
import { useContentContext } from '../../content-context';
import { MemberShipFormTemplate } from '../membership-form-template';
import { MembershipFormFieldTypes } from '../membership-form-template/contracts';
import { redirect } from '../membership-form-template/util';
import { IMemberLoginFormProps, MemberLoginFormModel } from './contracts';
import { memberLoginValidationSchema } from './validation-schema';

const OptionsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	justify-content: center;
	@media (max-width: 600px) {
		flex-direction: column;
		align-items: center;
	}
`;

export const MemberLoginForm: React.FC<IMemberLoginFormProps> = ({
	passwordResetUrl,
	redirectUrl,
	registerPageUrl,
	redirectToPrevious,
	membershipFieldDisplayName
}) => {
	const { contentId, requestToken, isLoggedIn } = useContentContext();

	if (isLoggedIn) {
		return (
			<div style={{ padding: '20px 10px', maxWidth: '500px', margin: '0 auto' }}>
				<MuiAlert severity="info">Logged in</MuiAlert>
			</div>
		);
	} else {
		return (
			<>
				<MemberShipFormTemplate<MemberLoginFormModel>
					contentId={contentId}
					recaptcha="memberLogin"
					submitButtonText="Log In"
					validationSchema={memberLoginValidationSchema}
					initialValues={{ userName: '', password: '', membershipFieldValue: '', rememberMe: false, contentId }}
					onSuccessFullSubmit={() => {
						if (redirectToPrevious) {
							window.history.back();
						} else if (redirectUrl?.url) {
							redirect(redirectUrl);
						} else {
							window.location.reload();
						}
					}}
					submitFunction={async values => {
						return await fetch('/Umbraco/Api/Membership/HandleLogin', {
							method: 'POST',
							headers: {
								Accept: 'application/json',
								'Content-Type': 'application/json',
								RequestVerificationToken: requestToken
							},
							body: JSON.stringify(values)
						});
					}}
					fields={[
						{
							name: 'userName',
							label: 'Email address',
							fieldType: MembershipFormFieldTypes.TextField
						},
						{
							name: 'membershipFieldValue',
							label: membershipFieldDisplayName,
							fieldType: MembershipFormFieldTypes.TextField
						},
						{
							name: 'password',
							label: 'Password',
							fieldType: MembershipFormFieldTypes.PasswordField
						},
						{
							name: 'rememberMe',
							label: 'Remember me',
							fieldType: MembershipFormFieldTypes.CheckboxField
						}
					]}
				/>
				<OptionsWrapper>
					{!strIsNullOrEmpty(passwordResetUrl?.url) ? (
						<FlexRowSmallSpaced style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
							<Typography
								sx={{ cursor: 'pointer', textDecoration: 'underline' }}
								onClick={() => {
									redirect(passwordResetUrl);
								}}
								color="primary"
							>
								Forgot password?
							</Typography>
							{!strIsNullOrEmpty(registerPageUrl?.url) ? (
								<FlexRowSmallSpaced style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
									<Typography>Don't have an account? </Typography>
									<Typography
										sx={{ cursor: 'pointer', textDecoration: 'underline' }}
										onClick={() => {
											redirect(registerPageUrl);
										}}
										color="primary"
									>
										Sign up
									</Typography>
								</FlexRowSmallSpaced>
							) : null}
						</FlexRowSmallSpaced>
					) : null}
				</OptionsWrapper>
			</>
		);
	}
};
